import axios from "axios";
import config from "../../config";

const BASE_URL = `${config.url}/api/auth`;

const AuthManager = {

  async login(credentials) {
    const response = await axios.post(`${BASE_URL}/login`, credentials);
    return response.data;
  },


  async register(userData) {
    const response = await axios.post(`${BASE_URL}/register`, userData);
    return response.data;
  },


  async getCurrentUser(token) {
    const response = await axios.get(`${config.url}/users/me`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },


  // ✅ Forgot Password Step 1: Send OTP (now JSON body)
  async requestPasswordResetOtp(email) {
    const response = await axios.post(`${BASE_URL}/forgot-password/request`, { email });
    return response.data;
  },

  // ✅ Forgot Password Step 2: Verify OTP (now JSON body)
  async verifyPasswordResetOtp(email, otp) {
    const response = await axios.post(`${BASE_URL}/forgot-password/verify`, { email, otp });
    return response.data;
  },

  // ✅ Forgot Password Step 3: Reset Password (now JSON body)
  async resetPassword(email, newPassword) {
    const response = await axios.post(`${BASE_URL}/forgot-password/reset`, { email, newPassword });
    return response.data;
  },

    // ✅ Registration OTP - Request
    async requestRegistrationOtp(email) {
      const response = await axios.post(`${BASE_URL}/register/request-otp`, { email });
      return response.data;
    },

    // ✅ Registration OTP - Verify
    async verifyRegistrationOtp(email, otp) {
      const response = await axios.post(`${BASE_URL}/register/verify-otp`, { email, otp });
      return response.data;
    },


  getUserDetails: async (userId, token) => {
    const response = await axios.get(`${BASE_URL}/user/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },


  async updateUserDetails(userData, token) {
    const response = await axios.post(`${BASE_URL}/update_user_details`, userData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  async uploadProfilePhoto(userId, file, token) {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axios.post(`${BASE_URL}/user/${userId}/upload-photo`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  },


};

export default AuthManager;
